export default __webpack_public_path__ + "static/media/1022.ff2d94b6.png";